import { useTranslation } from "react-i18next";
import { PMSimpleSelectorField } from "../PMSimpleSelector/PMSimpleSelectorField";
import { PMSimpleSelectorFieldV2 } from "../PMSimpleSelector/PMSimpleSelectorFieldV2";
import axios from "../../../api/axios";
import { useState, useEffect, useMemo } from "react";
import { mapErrors } from "../../Utils";
import { Form, Formik } from "formik";
import { ResourceLoading } from "../ResourceLoading";
import * as Yup from "yup";
import { toast } from "react-hot-toast";
import { fetchSystemTypes } from "../../../api/customer/system";
import SystemForm from "../../dashboard/customers/systems/SystemForm";
import { debounce } from "lodash";

export const SystemSelector = (props) => {
  const {
    setFieldValue,
    values,
    onChange,
    errors,
    module,
    module_param,
    fields,
  } = props;

  const name = "system_id";
  const label = props.label ? props.label : "System";
  const FETCH_URL = `/customers/${module_param}/systems/`;
  const CREATE_URL = `/customers/${module_param}/systems/`;
  const filters = null;

  const { t } = useTranslation();

  const [query, setQuery] = useState();
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState({
    id: 0,
    field1: "Ingen valgt",
    field2: null,
  });
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  const labelAction = {
    // path: "/dashboard/projects/" + selected?.id,
    // action: () => toast("test"),
  };


  const handleChange = (data) => {
    // getItem(data.selected.item.id);

    setSelected({
      id: data?.selected?.item?.id,
      field1: data?.selected?.item?.primary,
    });

    setOpen(false);
    if (values) {
      setFieldValue(name, data.selected.item.id);
    } else {
      onChange({ target: { name: name, value: data.selected.item.id } });
    }
  };

  const handleSelectFromForm = (data) => {
    setSelected({
      id: data?.id,
      field1: data?.displayTitle,
    });
    if (values) {
      setFieldValue(name, data?.id);
    } else {
      onChange({ target: { name: name, value: data?.id } });
    }
  };

  // Initialize selector display from provided selected prop and sync formik field
  useEffect(() => {
    if (props?.selected) {
      if (props.selected?.id) {
        setSelected({
          id: props.selected?.id,
          field1: props.selected?.displayTitle,
        });
        if (values && !values[name]) {
          setFieldValue(name, props.selected?.id);
        }
      } else {
        setSelected({
          id: 0,
          field1: "Ingen valgt",
          field2: null,
        });
        if (values && values[name]) {
          setFieldValue(name, null);
        }
      }
    }
  }, [props.selected]);

  const createView = (item) => {
    const CreateViewComponent = () => {
      const [typesState, setTypesState] = useState({
        isLoading: true,
        systemTypes: [],
      });
      const { systemTypes } = typesState;

      const createOrUpdate = (values) => {
        const data = {
          ...values,
          module: module,
          module_param: module_param,
        };
        return axios.post(CREATE_URL, data).then((res) => {
          return res;
        });
      };

      const getSystemTypes = async () => {
        return fetchSystemTypes()
          .then((res) => {
            if (res.data) {
              setTypesState((prevState) => ({
                ...prevState,
                isLoading: false,
                systemTypes: res.data,
              }));
            }
          })
          .catch((err) => {
            let errors = null;
            if (err?.data?.errors) {
              errors = mapErrors(err.data.errors);
            } else {
              errors = ["Something went wrong"];
            }
            setTypesState((prevState) => ({
              ...prevState,
              isLoading: false,
              systems: {},
              error: true,
              errors: errors,
            }));
          });
      };

      // Fields are rendered via SystemForm

      useEffect(() => {
        getSystemTypes();
      }, []);

      // No-op: selection in create view is handled by parent on success

    return (
      <>
        {loading ? (
          <ResourceLoading />
        ) : (
          <Formik
            initialValues={{
              id: null,

              product: item?.product
                ? item?.product
                : fields?.product
                ? fields?.product
                : null,
              system_m_name: item?.system_m_name
                ? item?.system_m_name
                : fields?.model_name
                ? fields?.model_name
                : null,
              product_id: item?.product_id
                ? item?.product_id
                : fields?.product_id
                ? fields?.product_id
                : null,
              serial_number: item?.serial_number
                ? item?.serial_number
                : fields?.serial_number
                ? fields?.serial_number
                : null,
              installation_year: item?.installation_year
                ? item?.installation_year
                : fields?.installation_year
                ? fields?.installation_year
                : null,
              production_year: item?.production_year
                ? item?.production_year
                : fields?.production_year
                ? fields?.production_year
                : null,
              system_type: item?.system_type,
              system_type_id: item?.type?.id,
              submit: null,
            }}
            validationSchema={Yup.object({
              system_type_id: Yup.number().nullable().required("Required"),
              production_year: Yup.string().nullable(),
              installation_year: Yup.string().nullable(),
              serial_number: Yup.string().nullable().required(t("Serial Number is required")),
            })}
            onSubmit={(values, helpers) => {
              try {
                toast.promise(createOrUpdate(values), {
                  loading: t("Saving...."),
                  success: (data) => {
                    if (data.status === 500) throw new Error("Server error");
                    if (data.status === 400) throw new Error("Server error");
                    if (data.data.errors)
                      throw new Error(mapErrors(data.data.errors));
                    // props.onRefresh(data.payload);
                    getItems();

                    if (data?.data?.id) {
                      handleSelectFromForm(data?.data);

                      setOpen(false);
                    }

                    return t("Data was saved!");
                  },
                  error: (error) => {
                    return t("Something went wrong. Could not save data!");
                  },
                });
                helpers.setStatus({ success: true });
                helpers.setSubmitting(false);
              } catch (err) {
                toast.error("Something went wrong...");
                console.error(err);
                helpers.setStatus({ success: false });
                helpers.setErrors({ submit: err.message });
                helpers.setSubmitting(false);
              }
            }}
          >
            {(formik) => (
              <Form>
                <SystemForm formik={formik} systemTypes={systemTypes} readOnly={false} />

                <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                  <button
                    type="button"
                    className="inline-flex align-right justify-center rounded-md border border-transparent bg-emerald-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:text-sm"
                    onClick={formik.submitForm}
                  >
                    {item?.id ? t("update") : t("create")}{" "}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        )}
      </>
    );
    };

    // Add display name for the component
    CreateViewComponent.displayName = 'CreateViewComponent';

    return <CreateViewComponent />;
  };

  const getItems = () => {
    setLoading(true);
    const params = {
      query: query ? query : "",
      page: 1,
      sortBy: "created_at",
      sort: "desc",
      filters: filters,
      view: null,
    };

    return axios({ method: "get", url: FETCH_URL, params: params })
      .then((response) => {
        if (response.data.data) {
          var array = [
            { id: null, value: null, primary: "Ingen valgt", secondary: null },
          ];
          if (!response.data.data) return array;
          response.data.data.map((row, i) => {
            const rowParams = {
              value: row.id,
              id: row.id,
              primary: row?.product?.displayTitle,
              secondary: row.serial_number,
            };
            array.push(rowParams);
          });
          setItems(array);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        return error.response.data;
      });
  };

  // createView uses SystemForm; rendering handled above

  const debouncedAction = debounce((controller) => {
    getItems();
  }, 500);

  useEffect(() => {
    if (open) {
      debouncedAction();
    }

    // Clean the debounced function on component unmount.
    return () => {
      debouncedAction.cancel();
    };
  }, [query, open]);

  // useEffect(() => {
  //   if (values[name]) {
  //     getItem(values[name]);
  //   }
  // }, [items]);

  return (
    <>
      <PMSimpleSelectorFieldV2
        errors={errors}
        name={name}
        label={t(label)}
        labelAction={labelAction}
        options={items}
        selected={selected}
        onChange={handleChange}
        onQueryChange={(query) => setQuery(query)}
        loading={loading}
        createView={createView}
        onClose={() => setOpen(!open)}
        open={open}
        fields={[
          {
            name: "name",
            label: "Name",
            type: "text",
            required: true,
            disabled: true,
          },
        ]}
      />
    </>
  );
};
